﻿
define([
    "log",
    "../libs/ace.min",
    "../libs/ace-extra.min",
    "../libs/jquery.mobile.custom.min",
    "../libs/jquery-ui",
    "../libs/jquery.countTo",
    "../libs/bootstrap",
    //'datatables',
    '../plugins/dataTables/jquery.dataTables',
], function (log) {
    log.log("jQuery plugins loaded.");
});


//////////////////
// WEBPACK FOOTER
// ./shim/jqueryplugins.js
// module id = 27
// module chunks = 2